import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.square-step-cards' ).each( function( index, component ) {
        const slider = new Splide( $( component ).find( '.splide--square-step-cards' )[0], {
          type: 'loop',
          gap: '2rem',
          perPage: 3,
          focus: 'center',
          perMove: 1,
          pagination: false,
          speed: 800,
          breakpoints: {
            768: {
              perPage: 1,
              gap: '1rem',
            },
          },
        } );

        const splideNav = slider.root.querySelector( '.square-step-cards__splide-nav' );

        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            arrows: isOverflow,
            drag: isOverflow,
            clones: isOverflow ? undefined : 0,
            focus: 0,
          };
          if ( !isOverflow ) {
            splideNav.style.display = 'none';
          } else {
            splideNav.style.display = 'flex';
          }
        } );

        slider.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'square-step-cards', COMPONENT );
} )( app );
